import { useState } from "react";
import { useNavigate } from "react-router-dom";
import efhSample from "../../../../ConceptOne/src/data/samples/efh-1.json";
import { C1_DOCUMENT_LOGO } from "../../../../ConceptOne/src/C1_Const";
import { emptyModel, modelFromSample } from "../../../../ConceptOne/src/lib/C1_initialModel";
import { EventKey } from "../../../eventLogger/EventKeys";
import { itx } from "../../../translationItx/itx";
import HeadBar from "../../HeadBar";
import FullSceenButton from "../../FullscreenButton";
import "./RegistrationProjectChoice.scss";

export default function RegistrationProjectChoice() {
  const navigate = useNavigate();
  const [projectName, setProjectName] = useState("");
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState("");

  function openProject(create: () => void, name: string) {
    setIsCreating(true);
    setError("");
    try {
      state.eventLogger.addEvent(EventKey.ConceptOneProjectCreationSubmitted, {
        source: "estadaProjectSelection", // no itx
        projectName: name,
      });
      create();
      state.eventLogger.addEvent(EventKey.ConceptOneProjectCreated, {
        source: "estadaProjectSelection", // no itx
        projectId: state.projectMetadata.id,
        projectName: name,
      });
      state.eventLogger.flush();
      navigate("/concept-one", { replace: true });
    } catch (reason) {
      console.error("[C1 Registration] Projekt konnte nicht geöffnet werden", reason);
      setError(
        reason instanceof Error
          ? reason.message
          : itx("registerProjectChoice.createError", "Das Projekt konnte nicht erstellt werden."),
      );
      setIsCreating(false);
    }
  }

  const trimmedProjectName = projectName.trim();

  return (
    <div className="App registrationProjectChoice">
      <FullSceenButton scope="project-selection" />
      <HeadBar />
      <main className="registrationProjectChoice__content">
        <img className="registrationProjectChoice__logo" src={C1_DOCUMENT_LOGO} alt="Concept One" />
        <h1>{itx("registerProjectChoice.title", "Womit möchtest du starten?")}</h1>
        <p className="registrationProjectChoice__intro">
          {itx(
            "registerProjectChoice.subtitle",
            "Wähle aus, ob du ein eigenes leeres Projekt beginnen oder unser Beispielprojekt ansehen möchtest.",
          )}
        </p>

        <div className="registrationProjectChoice__options">
          <section className="registrationProjectChoice__option">
            <h2>{itx("registerProjectChoice.emptyTitle", "Leeres C1-Projekt")}</h2>
            <p>
              {itx(
                "registerProjectChoice.emptyDescription",
                "Starte mit einem leeren Gebäude und gestalte dein Projekt selbst.",
              )}
            </p>
            <label
              htmlFor="registration-c1-project-name" // no itx
            >
              {itx("coverPage.projectName", "Projektname")}
            </label>
            <input
              id="registration-c1-project-name"
              value={projectName}
              maxLength={100}
              placeholder={itx("registerProjectChoice.projectNamePlaceholder", "Mein erstes Projekt")}
              onChange={(event) => setProjectName(event.target.value)}
            />
            <button
              type="button"
              className="button"
              disabled={isCreating || !trimmedProjectName}
              onClick={() => openProject(() => emptyModel(trimmedProjectName), trimmedProjectName)}
            >
              {itx("registerProjectChoice.createEmpty", "Leeres Projekt öffnen")}
            </button>
          </section>

          <section className="registrationProjectChoice__option">
            <h2>{itx("registerProjectChoice.exampleTitle", "Beispielprojekt")}</h2>
            <p>
              {itx(
                "registerProjectChoice.exampleDescription",
                "Öffne unser vorbereitetes Einfamilienhaus-Beispiel und entdecke Concept One.",
              )}
            </p>
            <button
              type="button"
              className="button"
              disabled={isCreating}
              onClick={() => openProject(() => modelFromSample(efhSample, "Einfamilienhaus 1"), "Einfamilienhaus 1")}
            >
              {itx("registerProjectChoice.openExample", "Beispielprojekt öffnen")}
            </button>
          </section>
        </div>
        {error && (
          <p className="registrationProjectChoice__error" role="alert">
            {error}
          </p>
        )}
      </main>
    </div>
  );
}
